import { useEffect } from "react";
import axios from "axios";
import { setProductNameNormalizeRuntimeConfig } from "../lib/productNameNormalize/runtime.js";

/** Підтягує правила з API після появи сесії (JWT у куках). */
export default function ProductNameNormalizeBootstrap({ user }) {
    useEffect(() => {
        if (!user) return undefined;
        let cancelled = false;
        (async () => {
            try {
                const res = await axios.get("/api/product-name-normalize-config", { withCredentials: true });
                if (!cancelled && res.data?.config) {
                    setProductNameNormalizeRuntimeConfig(res.data.config);
                }
            } catch {
                /* мережа / 401 — лишаємо дефолт у бандлі */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [user?._id || user?.id]);
    return null;
}
